import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { ContentWrapper, FileImage, NfId, SectionContainer, StyledDrawer, StyledKeyboardArrowRight } from '../styles';
import DetailByNf from './DetailByNf';
import FileSignatureWhite from '../../../../../../../../assets/images/file-signature-white.png';

const NfContainer = styled.div`
  padding: 12px 0;
  cursor: pointer;
  align-items: center;
  display: flex;
  color: var(--luft-secondary-darker);
  gap: 32px;
  i {
    font-size: 20px;
    margin-left: 12px;
  }

  &:hover {
    opacity: 0.7;
  }
`;

const AllNfDrawer = ({
  show, nfList, nfDetail, setNfDetail, ...props
}) => {
  const [shouldShow, setShouldShow] = useState(show);

  const setTimeoutRef = useRef(null);

  useEffect(() => {
    clearTimeout(setTimeoutRef.current);

    if (show) {
      setShouldShow(true);
    } else {
      requestAnimationFrame(() => {
        setTimeoutRef.current = setTimeout(() => {
          setShouldShow(false);
        }, 300);
      });
    }
  }, [shouldShow, show]);

  const DRAWER_ELEMENT_NAME = 'nf-drawer';


  return (shouldShow ? (
    <React.Fragment>
      <StyledDrawer
        data-name={DRAWER_ELEMENT_NAME}
        open={show}
        {...props}
      >
        <ContentWrapper noPadding>
          <SectionContainer byNf>
            {nfList.map(el => (
              <NfContainer
                key={`${el.nf}-${el.nfGroup}`}
                onClick={() => setNfDetail({
              isVisible: true,
              data: el,
            })}
              >
                <FileImage src={FileSignatureWhite} alt='File icon'/>
                <NfId>{`${el.nf}-${el.nfGroup}`}</NfId>
                <StyledKeyboardArrowRight />
              </NfContainer>
          ))}
          </SectionContainer>
        </ContentWrapper>
      </StyledDrawer>
      <DetailByNf
        show={nfDetail.isVisible}
        data={nfDetail.data}
        style={{ overflow: 'auto' }}
        onDismiss={() => setNfDetail({
          ...nfDetail,
          isVisible: false,
        })}
      />
    </React.Fragment>
  ) : null);
};

export default AllNfDrawer;
